import { useMutation } from '@apollo/client'

import { OrderReviewGigaQueryDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'
import { PRODUCT_COLOR_CODE } from 'shop/products/traits'

const upsertOrderQuantities = atlas`#graphql
  mutation UpsertOrderQuantitiesDupe1($input: UpsertOrderQuantitiesInput!) {
    upsertOrderQuantities(input: $input) {
      updatedOrderIds
    }
  }
`

export const withUpsertOrderQuantities = (WrappedComponent) => (props) => {
  const [handleUpsertOrderQuantities, { loading }] = useMutation(
    upsertOrderQuantities,
    {
      client: atlasClient,
      refetchQueries: [
        {
          query: OrderReviewGigaQueryDocument,
          variables: {
            filters: {
              ids: props.orderIds,
            },
            traitCodes: PRODUCT_COLOR_CODE,
            limit: 20,
            offset: 0,
          },
        },
      ],
    },
  )

  return (
    <WrappedComponent
      {...props}
      handleUpsertOrderQuantities={(input) =>
        handleUpsertOrderQuantities({
          variables: { input },
        })
      }
      updatingUnits={loading}
    />
  )
}

export default withUpsertOrderQuantities
